var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardTidakSetoran(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#FF0000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2006_6618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.05 33.18L15.555 36.03C15.4263 36.0661 15.2897 36.0623 15.1632 36.0191C15.0368 35.9759 14.9264 35.8953 14.8468 35.788C14.7671 35.6807 14.7219 35.5517 14.7171 35.4181C14.7123 35.2846 14.7482 35.1527 14.82 35.04C15.8414 33.4955 17.3689 32.3552 19.14 31.815L24.195 30.315L25.05 33.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 33.18L32.745 36.03C32.8747 36.0705 33.0137 36.07 33.1431 36.0286C33.2724 35.9872 33.3859 35.9069 33.4679 35.7986C33.55 35.6903 33.5966 35.5593 33.6014 35.4236C33.6063 35.2878 33.5691 35.1539 33.495 35.04C32.4718 33.491 30.9378 32.3498 29.16 31.815L24.12 30.315L23.25 33.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.44 14.1899L9.22498 32.8799C9.22498 32.8799 19.2 31.3799 22.92 33.7949H24.18V31.0349L11.865 14.7149L10.44 14.1899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.44 14.19L10.14 29.895C10.14 29.895 14.37 29.76 15.975 29.895C18.7324 30.0207 21.4682 30.4431 24.135 31.155V15.105C24.135 15.105 20.235 14.82 15.915 14.19C14.0919 14.0721 12.2631 14.0721 10.44 14.19Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.305 11.73L13.005 27.435C14.9451 27.2397 16.8999 27.2397 18.84 27.435C23.445 28.515 24.105 31.035 24.105 31.035V15.03C24.105 15.03 23.1 12.36 18.78 11.73C16.9569 11.612 15.1281 11.612 13.305 11.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8 14.1899L39.03 32.8799C39.03 32.8799 29.055 31.3799 25.335 33.7949H24.03V31.0349L36.36 14.7149L37.8 14.1899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8 14.19L38.085 29.895C38.085 29.895 33.855 29.76 32.25 29.895C29.4974 30.0192 26.7664 30.4416 24.105 31.155V15.105C24.105 15.105 27.99 14.82 32.31 14.19C34.1381 14.0721 35.9719 14.0721 37.8 14.19Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.935 11.73L35.22 27.435C33.2799 27.2397 31.3251 27.2397 29.385 27.435C24.78 28.515 24.12 31.035 24.12 31.035V15.03C24.12 15.03 25.125 12.39 29.445 11.76C31.2724 11.632 33.1063 11.622 34.935 11.73Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2006_6618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardTidakSetoran);
export default __webpack_public_path__ + "static/media/dashboard_tidak_setoran.a56def7365852efa4d31354ca6c12d14.svg";
export { ForwardRef as ReactComponent };